import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { useInjectScript } from './useInjectScript';
import { API_HEADER_V1, apiCallWithApiKey } from '../services/api';
import { useMixpanel } from './useMixpanel';
import { EV_RECAPTCHA } from '../services/mixpanel';

// https://developers.google.com/recaptcha/docs/v3
const RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js'
  + `?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
export const PETCLOUD_ORIGIN = 6;

export const useRecaptchaValidator = () => {
  const [isValid, setValid] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const { sendEvent } = useMixpanel();
  const store = useSelector(({
    personalInformation,
  }) => ({ personalInformation }), shallowEqual);

  const { LoginEmail } = store.personalInformation?.userInfo;

  const scriptRecaptchaLoaded = useInjectScript({
    id: 'reCAPTCHAv3',
    src: RECAPTCHA_SRC,
  });

  const onSubmit = async (recaptcha) => {
    setIsLoading(true);
    const url = 'purchase/Recaptcha/Siteverify';
    const body = {
      Email: LoginEmail,
      Origin: PETCLOUD_ORIGIN,
      Token: recaptcha,
    };

    try {
      const response = await apiCallWithApiKey(url, {
        body,
        headers: API_HEADER_V1,
        method: 'POST',
      });

      if (response.IsValid) {
        setValid(true);
      } else {
        sendEvent(EV_RECAPTCHA({
          error: response.Message,
          token: recaptcha,
        }));
      }
    } catch (error) {
      sendEvent(EV_RECAPTCHA({
        error: `Error ${error.message}`,
        token: recaptcha,
      }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (scriptRecaptchaLoaded) {
      window.grecaptcha?.ready(() => {
        window.grecaptcha
          .execute(process.env.REACT_APP_RECAPTCHA_KEY, { action: 'submit' })
          .then(onSubmit);
      });
    }
  }, [scriptRecaptchaLoaded]);

  return {
    loading,
    recaptchaValidate: isValid,
  };
};

export const useGetRecaptchaToken = () => {
  const scriptRecaptchaLoaded = useInjectScript({
    id: 'reCAPTCHAv3',
    src: RECAPTCHA_SRC,
  });

  const getRecaptchaToken = async () => new Promise((resolve) => {
    if (window.grecaptcha || scriptRecaptchaLoaded) {
      window.grecaptcha?.ready(() => {
        window.grecaptcha
          .execute(process.env.REACT_APP_RECAPTCHA_KEY, { action: 'submit' })
          .then((token) => resolve(token))
          .catch(() => resolve(null));
      });
    }
  });

  return getRecaptchaToken;
};
